import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    EnumStatisticChartGroupByPeriod
} from "../../../../../../server/routes/statistic/types";
import MenuButton from "../../../../components/MenuButton";
import {
    actionGroupByPeriodChange
} from "../../../../store/statisticChart/actions";
import { useStatusGroup } from "../../StatusGroupProvider";
import useLoadingAnyDateChart from "../hooks/useLoadingAnyDateChart";
import { SelectorGroupByPeriodFC } from "./types";

const SelectorGroupByPeriod: SelectorGroupByPeriodFC = () => {
  const { statusGroup } = useStatusGroup();
  const { groupByPeriod, isLoading } = useSelector(
    ({
      statisticChart: {
        [statusGroup]: { groupByPeriod, sending },
      },
    }) => ({
      groupByPeriod,
      isLoading: sending,
    })
  );
  // const loading = useLoading();
  const loading = useLoadingAnyDateChart();
  const dispatch = useDispatch();
  const handlerSelect = (groupByPeriod: EnumStatisticChartGroupByPeriod) => {
    dispatch(actionGroupByPeriodChange(statusGroup, groupByPeriod));
    loading({ groupByPeriod });
  };
  return (
    <MenuButton
      ButtonProps={{
        size: "small",
        variant: "outlined",
        color: "primary",
        disabled: isLoading,
      }}
      active={groupByPeriod ?? ""}
      items={[
        {
          label: "День",
          code: EnumStatisticChartGroupByPeriod.DAY,
          onClick: () => handlerSelect(EnumStatisticChartGroupByPeriod.DAY),
        },
        {
          label: "Неделя",
          code: EnumStatisticChartGroupByPeriod.WEEK,
          onClick: () => handlerSelect(EnumStatisticChartGroupByPeriod.WEEK),
        },
        {
          label: "Месяц",
          code: EnumStatisticChartGroupByPeriod.MONTH,
          onClick: () => handlerSelect(EnumStatisticChartGroupByPeriod.MONTH),
        },
      ]}
    />
  );
};

export default SelectorGroupByPeriod;
